/* Built In Imports */
/* External Imports */
import axios from 'axios';

/* Internal Imports */
/* Components */
import config from '@config';
import { tryGetPreviewData } from 'utils';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';

let isCache = false;
const API_PREFIX = '/content/fetchiso';

export const fetchPageData = async (region, lang, slug = ``, previewData) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  } else {
    const pageData = await new IsoBackendHttpService().get(
      `${API_PREFIX}/content`,
      !isCache,
      {
        params: {
          format: 'json',
          slug: slug ? `grace-of-yoga/${slug}` : `grace-of-yoga`,
          region,
          lang,
        },
      }
    );
    return pageData;
  }
};

export const fetchProgInfo = async () => {
  // consoleLog('fetchProgInfo statrs');
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: config.GOY_PRICE_API
  });
  return resp?.data;
};

export const fetchInPersonPageData = async (region, lang, slug = ``, previewData) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  } else {
    const pageData = await new IsoBackendHttpService().get(
      `${API_PREFIX}/content`,
      !isCache,
      {
        params: {
          format: 'json',
          slug: slug ? `grace-of-yoga-in-person/${slug}` : `grace-of-yoga-in-person`,
          region,
          lang,
        },
      }
    );
    return pageData;
  }
};